import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  sectionHome:{
    height: 'calc(100vh - 80px)',
    display:'flex',
    alignItems:'center',

    '@media screen and (max-width: 700px)': {
      height: '100%',
      marginTop: 10,
      marginBottom: 10,
    },
  },
  containerSkeleton: {
    display: 'flex',
  },
  title: {
    color: 'white',
    fontWeight: 'bolder !important',
    textAlign: 'start',
    margin: 0,
    paddingBottom: 10,
  },

  containerProfs: {
    height: '100%',
    padding: '20px 10px',
  },
  formSelect: {
    margin: 0,
    height: '100%',
    backgroundColor: 'white',
    borderRadius: 5,
    color: 'black',

    '& label': {
      color: 'black !important',
    },
  },
  selectNative: {
    '& select': {
      paddingTop: 13,
      paddingBottom: 12,
    },
  },
  buttonSearch: {
    gap: 10,
    minWidth: '200px',
  },
  cardCarousel: {
    margin: '16px',
    maxWidth: '1200px',
    height: '100%',
    width: '100%',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100% - 32px)',
    overflowY: 'auto',
    backgroundColor: '#035ea7',

    [theme.breakpoints.down('700')]: {
      margin: 0,
    }
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    background: '#035ea7',
    padding: '5px 10px',
    gap: 5,
    flexWrap: 'wrap',
  },
  containerForm: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 1fr',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 10,
    padding: '10px 0',

    '@media (max-width: 950px)': {
      gridTemplateColumns: '1fr',
    }
  },
  gridContainer: {
    display:'grid',
    gridTemplateColumns:'repeat(4,1fr)',
    gap: 10,

    '@media (max-width: 1050px)': {
      gridTemplateColumns: 'repeat(3,1fr)',
    },
    '@media (max-width: 800px)': {
      gridTemplateColumns: 'repeat(2,1fr)',
    },
    '@media (max-width: 500px)': {
      gridTemplateColumns: '1fr',
    },
  },
  more: {
    minWidth: '250px !important',
    marginTop: '20px !important',
    marginBottom: '10px !important',
  },
}))
